let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import Confetti from 'growth-onboarding-confetti/Confetti';
import OnboardingTourButtons from '../OnboardingTourButtons';
import { useTourContext, useIsLastStep } from '../../../js/hooks/tour';

// Hide the banner from modals and show it only after the user action on the modal CTA.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HandholdingBannerGlobalStyle = createGlobalStyle(_t || (_t = _`
.uiFullScreenBackground #onboarding-tours-banner-frame {
  filter: blur(5px);
  z-index: auto !important
  }
  `));
const OnboardingTourModal = props => {
  const {
    step: {
      title,
      text,
      actionText,
      buttons,
      modal
    },
    onCloseComplete,
    onOpenStart,
    rootNode,
    'data-test-step-index': dataTestStepIndex
  } = props;
  const modalProps = modal !== undefined && typeof modal !== 'boolean' ? modal : {};
  const {
    showConfetti
  } = modalProps;
  const {
    tour
  } = useTourContext();
  const isOnLastStep = useIsLastStep();
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-step-index": dataTestStepIndex,
    onCloseComplete: onCloseComplete,
    onOpenStart: onOpenStart,
    rootNode: rootNode,
    use: "conversational",
    width: 550,
    children: [showConfetti && /*#__PURE__*/_jsx(Confetti, {
      widthPercentage: 300
    }), /*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockStart: "800",
      children: [isOnLastStep && /*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "onboarding-tour-modal-close-button",
        onClick: () => {
          tour.finish();
        }
      }), /*#__PURE__*/_jsx(Text, {
        as: "h3",
        textAlign: "start",
        typography: "heading-300",
        children: title
      }), /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "600",
        textAlign: "start",
        children: text
      }), actionText && /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "400",
        textAlign: "start",
        children: /*#__PURE__*/_jsx("strong", {
          children: actionText
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(OnboardingTourButtons, {
        buttons: buttons || []
      })
    }), /*#__PURE__*/_jsx(HandholdingBannerGlobalStyle, {})]
  });
};
export default OnboardingTourModal;